import React, { useEffect, useState } from "react";

const AntiCopy = () => {
  const [customMenuVisible, setCustomMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [clickedLink, setClickedLink] = useState(null); // Store the clicked link's URL

  useEffect(() => {
    // Function to handle right-click on the page
    const handleRightClick = (e) => {
      const targetTag = e.target.tagName.toLowerCase();

      if (targetTag === "a") {
        // Prevent default right-click menu for links
        e.preventDefault();

        // Show custom context menu for links
        setCustomMenuVisible(true);
        setMenuPosition({ x: e.pageX, y: e.pageY });
        setClickedLink(e.target.href); // Store the link's URL
      } else {
        // Block right-click globally for other elements
        e.preventDefault();

        // Hide custom menu if right-click is not on a link
        setCustomMenuVisible(false);
      }
    };

    // Function to disable keyboard shortcuts for Developer Tools
    const disableKeyboardShortcuts = (e) => {
      const restrictedKeys = ["c", "u", "s", "p", "j", "i"];
      const isCtrlOrMeta = e.ctrlKey || e.metaKey;

      if (
        (isCtrlOrMeta && restrictedKeys.includes(e.key.toLowerCase())) ||
        (e.shiftKey && isCtrlOrMeta && ["i", "c", "j"].includes(e.key.toLowerCase())) ||
        e.key === "F12"
      ) {
        e.preventDefault();
      }
    };

    // Disable text selection globally
    const disableTextSelection = () => {
      document.body.style.userSelect = "none";
      document.body.style.webkitUserSelect = "none"; // For Safari
      document.body.style.msUserSelect = "none"; // For IE/Edge
    };

    // Attach event listeners
    document.addEventListener("contextmenu", handleRightClick);
    document.addEventListener("keydown", disableKeyboardShortcuts);
    disableTextSelection();

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
      document.removeEventListener("keydown", disableKeyboardShortcuts);
      document.body.style.userSelect = "auto"; // Re-enable text selection
      document.body.style.webkitUserSelect = "auto"; // Re-enable for Safari
      document.body.style.msUserSelect = "auto"; // Re-enable for IE/Edge
    };
  }, []);

  // Hide custom menu when clicking elsewhere
  const handlePageClick = () => {
    setCustomMenuVisible(false);
  };

  useEffect(() => {
    document.addEventListener("click", handlePageClick);
    return () => {
      document.removeEventListener("click", handlePageClick);
    };
  }, []);

  // Function to open a link in a new window
  const openInNewWindow = () => {
    if (clickedLink) {
      window.open(clickedLink, "_blank", "width=800,height=600");
    }
    setCustomMenuVisible(false); // Hide the custom menu
  };

  // Function to open a link in a new tab
  const openInNewTab = () => {
    if (clickedLink) {
      window.open(clickedLink, "_blank");
    }
    setCustomMenuVisible(false); // Hide the custom menu
  };

  return (
    <div>
      {/* Custom Context Menu */}
      {customMenuVisible && (
        <ul
          style={{
            position: "absolute",
            top: `${menuPosition.y}px`,
            left: `${menuPosition.x}px`,
            background: "#fff",
            border: "1px solid #ccc",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            listStyle: "none",
            padding: "10px",
            zIndex: 1000,
          }}
        >
             <li
            style={{
              padding: "5px 10px",
              cursor: "pointer",
            }}
            onClick={openInNewTab}
          >
            Open in New Tab
          </li>
          <li
            style={{
              padding: "5px 10px",
              cursor: "pointer",
            }}
            onClick={openInNewWindow}
          >
            Open in New Window
          </li>
         
        </ul>
      )}
    </div>
  );
};

export default AntiCopy;
